const ROUTES = {
  ROOT: '/',
  VERSION: '/version',
  ERROR: '/error/:code?',

  REGISTER_START: '/register/start',
  REGISTER_ENTER_USERNAME: '/register/enter-username',
  REGISTER_ONE_TIME_CODE: '/register/onetimecode',
  REGISTER_SET_YOUR_PASSWORD: '/register/set-your-password',

  MANUAL_REG_FIND_CUSTOMER: '/manual-reg/find-your-email',
  MANUAL_REG_ACCOUNT_NUMBER: '/manual-reg/account-number',
  MANUAL_REG_ONE_TIME_CODE: '/manual-reg/onetimecode',
  MANUAL_REG_SET_YOUR_PASSWORD: '/manual-reg/set-your-password',

  RESET_PASSWORD_START: '/reset-password/start',
  RESET_PASSWORD_ENTER_USERNAME: '/reset-password/enter-username',
  RESET_PASSWORD_ONE_TIME_CODE: '/reset-password/onetimecode',
  RESET_PASSWORD_SET_YOUR_PASSWORD: '/reset-password/set-your-password',

  FORGOT_USERNAME_FIND_CUSTOMER: '/forgot-username/find-customer',
  FORGOT_USERNAME_ACCOUNT_NUMBER: '/forgot-username/account-number',
  FORGOT_USERNAME_ACCOUNT_FOUND: '/forgot-username/account-found',

  LOGIN: '/login',
  LOGIN_START: '/login/start',

  CALL_CENTRE_REGISTER_SET_YOUR_PASSWORD: '/call-centre-register/set-your-password',
  CALL_CENTRE_REGISTER_THANKYOU: '/call-centre-register/thankyou',

  CALL_CENTRE_RESET_PASSWORD_SET_YOUR_PASSWORD: '/call-centre-reset/set-your-password',
  CALL_CENTRE_RESET_PASSWORD_THANKYOU: '/call-centre-reset/thankyou',
};

export { ROUTES };
